<template>
  <p
    v-if="pendingAction"
    class="mb-8 text-center m-auto"
  >
    Veuillez vous connecter ou créer votre compte pour valider votre action.<br>
    Vos configurations ne seront pas supprimées.
  </p>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PendingAction',
  computed: mapState('configuration', ['pendingAction']),
};
</script>
